// @flow
import * as React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";

import Navbar from "../../Layouts/Navbar";
import Header from "../../Layouts/Header";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {GoStarFill} from "react-icons/go";

export default function CompaniesList(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [servitorCompanies, setServitorCompanies] = React.useState([]);

    React.useEffect(() => {
        const params = {
            count : 8,
            list: 1,
            orderBy: 'id',
            orderType: 'desc',
            service_group_id: id
        }

        API.getServitorCompanies(params)
            .then((response) => {
                setServitorCompanies(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });

    }, [id]);
    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='لیست شرکت های خدماتی' hasBack={true} />

            {/* Servitor */}
            <section className="container-fluid  mt-3 py-5 rtl px-0  ">

                <div className="row mx-3">
                    {
                        servitorCompanies.map (company => {
                            return (
                                <div className="col-12 p-2" key={company.id}
                                     onClick={
                                         () => {
                                             navigate(`/company/${company.id}`);
                                         }
                                     }
                                >
                                    <div className="servitor-container row">
                                        <div className="col-2 servitor-image p-2">
                                            <img src={company.image} alt={company.title} />
                                        </div>
                                        <div className="col-10">
                                            <div className="title py-2 pe-2">
                                                {company.title}
                                                <span className='float-start fw-bold text-small-2 badge badge-pill badge-primary bg-secondary-subtle bg-opacity-75 text-dark'>
  <GoStarFill className='text-big-1 text-warning' />
                                                    {company.score}

                                                </span>
                                            </div>
                                            <div className="description pe-2">
                                                {company.brief.substr(0,100)} ...
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )} )

                    }
                </div>
            </section>

            <Navbar />
        </React.Fragment>
    );
};
